import { Box, Button, styled } from '@mui/material';
import { PDFViewerViewMode } from './PDFViewer.props';

export const THUMBNAIL_WIDTH = 450;

export const PdfViewerWrapper = styled('div')<{ $viewMode?: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'stretch' : 'center',
  position: 'relative',
  animation: 'fadeInUp 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards',
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export const PdfViewerContentWrapper = styled('div')<{ $viewMode: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'grid' : 'flex',
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? undefined : 'column',
  gridTemplateColumns:
    $viewMode === PDFViewerViewMode.THUMBNAIL ? `repeat(auto-fill, minmax(${THUMBNAIL_WIDTH}px, 1fr))` : undefined,
  gap: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : '10px',
  padding: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : undefined,
  width: $viewMode === PDFViewerViewMode.THUMBNAIL ? '100%' : undefined,
}));

export const PdfViewerThumbnailWrapper = styled('div')<{ $viewMode: PDFViewerViewMode }>(({ $viewMode }) => ({
  display: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'grid' : 'flex',
  flexDirection: $viewMode === PDFViewerViewMode.THUMBNAIL ? 'row' : 'column',
  gap: $viewMode === PDFViewerViewMode.THUMBNAIL ? '20px' : '10px',
  alignItems: 'center',
  height: '100%',
  overflow: 'auto',
}));

export const PdfViewerStateContainer = styled('div')({
  padding: '20px',
  textAlign: 'center',
});

export const PdfPageViewerLoader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px',
  animation: 'pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%': {
      opacity: 0.6,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.6,
    },
  },
});

export const StyledCitationNavigatorWrapper = styled('div')({
  position: 'fixed',
  bottom: 24,
  right: 24,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  background: 'rgba(0,0,0,0.75)',
  color: '#fff',
  borderRadius: 20,
  padding: '4px 12px',
  fontSize: 13,
  zIndex: 1300,
  boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
});

export const StyledCitationNavButton = styled(Button)({
  minWidth: 32,
  padding: '2px 6px',
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.5)',
  fontSize: 16,
});

export const StyledHighlightableTextNotification = styled(Box)({
  position: 'fixed',
  bottom: '24px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: '#1976d2',
  color: 'white',
  padding: '12px 24px',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 10000,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  fontWeight: 500,
  animation: 'slideUp 0.3s ease-out',
  cursor: 'pointer',
});
